// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* eslint-disable */
export const APP_VERSION = '1.1.0';
export const APP_NAME = 'bitf-angular-boilerplate';
export const FILE_HASH = '1594309810173';
export const BUILD_DATE = '2020-07-09T15:50:10.173Z';
/* eslint-enable */
